import request from "@/utils/request";
export function fetchList(data) {
  return request({
    url: "/whg-park/api/theaterAreaPrice/list",
    method: "post",
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: "/whg-park/api/theaterAreaPrice/get",
    method: "post",
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: "/whg-park/api/theaterAreaPrice/delete",
    method: "post",
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: "/whg-park/api/theaterAreaPrice/insert",
    method: "post",
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: "/whg-park/api/theaterAreaPrice/update",
    method: "post",
    data: data
  });
}